import { utils } from '@sfaas/util';

export default {
	servicePrograms_: state => {
		return state.servicePrograms;
	},
	serviceUrls_: state => {
		if (state.serviceProgram === 'Java') return state.javaServiceUrls;
		else return state.cSharpServiceUrls;
	},
	bindSql_: state => {
		return state.selectedContent.BindSqlText;
	},
	staticSql_: state => {
		return state.selectedContent.StaticSqlText;
	},
	tabs_: state => {
		return state.sqlContent;
	},
	show_: state => {
		const { show } = state.popupParams;
		return show;
	},
	totalSize_: state => {
		const { pagingInfo } = state;
		const { totalSize } = pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pagingInfo } = state;
		const { pageUnit } = pagingInfo;
		return pageUnit;
	},
	urlSearchParams_: state => {
		const { searchParams, pagingInfo } = state;
		const urlSearchParams = new URLSearchParams();
		// Object.keys(searchParams).forEach(key => {
		// 	const value = searchParams[key];
		// 	console.log('key', key);
		// 	console.log('value', value);
		// 	if (!utils.$sf_isNull(value) && !value.includes('ALL')) {
		// 		urlSearchParams.set(key, value);
		// 	}
		// });
		// TODO
		Object.keys(pagingInfo).forEach(key => {
			const validKeys = ['currentPage', 'pageUnit'];
			const value = pagingInfo[key];
			if (validKeys.includes(key)) {
				urlSearchParams.set(key, value);
			}
		});
		return urlSearchParams.toString();
	}
};
